import React from 'react';

import type { DataTableProps } from '@column/ui';

import { LogoLoading } from '~/elements/LogoLoading';

export const tableDefaults = {
  loadingContent: <LogoLoading />,
  emptyMessage: 'No entries found',
  rowClassName: 'min-h-11',
} satisfies Partial<DataTableProps<Record<string, any>>>;
